import React from "react";
import CommunityList from "./CommunityList";

const Community = () => {
  return (
    <>
      <CommunityList />
    </>
  );
};
export default Community;
